import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_billing_record_activity_listService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList($inParams: { billingTaskId: number, $top?: number, $skip?: number }): Promise<{ result?: { billingTaskId?: number, activityTitle?: string, activityDetails?: string, activityUser?: string, activityStyle?: string, activityDate?: string }[], totalCount?: number }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.billingTaskId)) {
      $missingRequiredInParams.push('\'billingTaskId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { billingTaskId?: number, $keys: number[] }): Promise<{ result?: { billingTaskId?: number, activityTitle?: string, activityDetails?: string, activityUser?: string, activityStyle?: string, activityDate?: string }[] }> {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      billingTaskId: number    }) {
        if(isNil($inParams.billingTaskId)) {
          return true; 
        }
      return false;
    }
}
